import classNames from "classnames";
import React, { ReactElement } from "react";

import Button, { ButtonProps } from "./Button";
import styles from "./FlatButton.module.css";

export type FlatButtonProps = ButtonProps;

export default React.forwardRef<HTMLButtonElement, FlatButtonProps>(
  function FlatButton(
    { className, ...restProps }: FlatButtonProps,
    ref
  ): ReactElement {
    return (
      <Button
        ref={ref}
        className={classNames(styles.root, className)}
        {...restProps}
      />
    );
  }
);
